import React from "react";
import {Avatar, Button} from "antd";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {globalOpenGoLiveModalState, globalUserDetailState,} from "../../../../../_common/global_state";
import dummyImg from "../../../../../assets/image/dummy.png";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useVerification} from "../../../../../_common/_authorize";
import {PopoverContentConfig} from "./popoverContentConfig";

const PopoverContent = (props) => {
    const {setPopoverOpen, setOpenQrModal} = props;
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {handleTokenExpiration} = useVerification();

    const userDetails = useRecoilValue(globalUserDetailState);
    const setOpenGoLiveModal = useSetRecoilState(globalOpenGoLiveModalState);

    return (
        <div>
            <div className={"avatar-section"}>
                <Avatar className={"profile-avatar"} size={48} src={userDetails?.profileImage || dummyImg}/>
                <div>
                    <div className={"username"}>{userDetails?.username}</div>
                    <div className={"header-tag-container"}>
                        <span className={"account-type-badge"}>{t(`user.statusTag.${userDetails?.clientAccountType}`)}</span>
                        <span className={"rank-badge"}>{userDetails?.rank?.name}</span>
                    </div>
                </div>
            </div>
            {userDetails?.clientAccountType === "demo" && (
                <Button
                    type={"primary"}
                    className={"go-live-button"}
                    onClick={() => setOpenGoLiveModal(true)}
                >
                    {t("common.goLive")}
                </Button>
            )}
            <div className={"popover-select-item-list mt-2"}>
                <Button
                    type={"text"}
                    onClick={() => {
                        setOpenQrModal(true);
                        setPopoverOpen(false);
                    }}
                >
                    {t("referral.modal.title")}
                </Button>
                <Button
                    type={"text"}
                    onClick={() => navigate("/profile")}
                >
                    {t("common.editProfile")}
                </Button>
                <Button
                    type={"text"}
                    onClick={() => handleTokenExpiration(true)}
                >
                    {t("common.logOut")}
                </Button>
            </div>
        </div>
    );
};

export default PopoverContent;
